const topicTags = [
  { name: '明星塌房', count: '2.8万', color: 'primary' },
  { name: '恋情曝光', count: '1.9万', color: 'accent' },
  { name: '综艺黑幕', count: '1.5万', color: 'secondary' },
  { name: '网红翻车', count: '2.1万', color: 'primary' },
  { name: '税务风波', count: '1.2万', color: 'accent' },
  { name: '整容争议', count: '9800', color: 'secondary' },
  { name: '剧组不和', count: '7600', color: 'primary' },
  { name: '私生活爆料', count: '3.2万', color: 'accent' },
  { name: '合同纠纷', count: '5400', color: 'secondary' },
  { name: '人设崩塌', count: '2.5万', color: 'primary' },
];

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-500/10', text: 'text-primary-500', border: 'border-primary-500/20' },
  accent: { bg: 'bg-accent-500/10', text: 'text-accent-500', border: 'border-accent-500/20' },
  secondary: { bg: 'bg-secondary-500/10', text: 'text-secondary-500', border: 'border-secondary-500/20' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-accent-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicTags.map((topic) => {
            const c = colorMap[topic.color];
            return (
              <div
                key={topic.name}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full ${c.bg} border ${c.border} cursor-pointer hover:scale-105 transition-transform`}
              >
                <span className={`text-sm font-medium ${c.text}`}>#{topic.name}</span>
                <span className="text-xs text-foreground-400">{topic.count}讨论</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}